import React from "react";

import NoneAuthLayoutSwitch from "../none-auth-layout-switch";
import { BrandingData } from "admin-portal/settings/branding";
import ResetPasswordComponent from "./reset-password-component";

const AdminResetPasswordPage = (props: any) => {
  document.title = "Reset Password" + BrandingData.titleSuffix;

  return (
    <React.Fragment>
      <NoneAuthLayoutSwitch>
        <ResetPasswordComponent />
      </NoneAuthLayoutSwitch>
    </React.Fragment>
  );
};

export default AdminResetPasswordPage;
